import ComingSoonLogo from '../../uber-assets/ROTYlogo_500x250.png';

export function ComingSoon() {
    return (
        <div className="coming-soon">
            <div className='coming-soon-content'>
                <img src={ComingSoonLogo} alt="Uber Eats Restaurant of the Year 2026 logo" />
                <h1>LAUNCHING SOON</h1>
            </div>
        </div>
    )
}